// ### EventEmitter
//
// A simple event emitter.

'use strict';

var _ = require('./vendor/underscore');
var _logger = require('./logger');


function EventEmitter() {
	this._events = {};
}

var slice = _.toArray;
var isArray = _.isArray;
var now = _.now;

function indexOf(list, fn, context) {
	for (var i = 0, endi = list.length; i < endi; i += 1) {
		if (list[i].fn === fn && list[i].context === context) {
			return i;
		}
	}
	return -1;
}

function throwException(e) {
	return function () { throw e; };
}

function emitEvent(type, data, event) {
	/* jshint validthis:true */
	var eventQ = slice(this._events[type] || []);  // copy to prevent infinite loop if event handlers add event handlers
	for (var obj, i = 0, endi = eventQ.length; i < endi; i += 1) {
		obj = eventQ[i];
		try {
			// If options['apply'] is set and data is an array, use fn.apply();
			// otherwise, pass data and metadata to callback function.
			if (isArray(data) && obj.options && obj.options.apply) {
				obj.fn.apply(obj.context, data);
			} else {
				obj.fn.call(obj.context, data, {
					target: obj.context,
					type: event || type,
					timeStamp: now()
				});
			}
		} catch (e) {
			_logger.error('exception thrown from handler of "' + (event || type) + '" event (check e.stack or obj.fn to see what function threw the exception)', e);
			if ('stack' in e) {
				_logger.error(e.stack);
			}
			window.setTimeout(throwException(e), 0);
		}
	}
}

var mixinPrototype = {
	on: function on(event, fn, context, options) {
		if (typeof fn !== 'function') {
			_logger.error('A callback function was not provided to listen to the event "' + event + '".');
			return this;
		}
		context = context || this;
		var events = (this._events = (this._events || {}));
		var eventQ = events[event] || (events[event] = []);
		if (indexOf(eventQ, fn, context) === -1) {  // prevent duplicates
			eventQ.push({
				fn: fn,
				context: context,
				options: options
			});
		}
		return this;
	},
	once: function once(event, fn, context, options) {
		if (typeof fn !== 'function') {
			_logger.error('A callback function was not provided to listen to the event "' + event + '" once.');
			return;
		}
		context = context || this;
		var newFn = function (/*data, meta*/) {
			this.off(event, newFn);
			fn.apply(context, arguments);
		};
		this.on(event, newFn, this, options);
		return newFn;
	},
	off: function off(event, fn, context) {
		var events = this._events;
		if (!(event in events)) {
			_logger.warn('The provided callback function was not listening to the event "' + event + '".');
			return this;
		}
		context = context || this;
		var eventQ = events[event];
		var fnIndex = indexOf(eventQ, fn, context);
		if (fnIndex !== -1) {
			eventQ.splice(fnIndex, 1);
			if (eventQ.length === 0) {
				delete events[event];
			}
		}
		return this;
	},
	emit: function emit(event, data) {
		// trigger handlers for this event
		emitEvent.call(this, event, data);
		// trigger any 'all' handlers
		emitEvent.call(this, '*', data, event);
		return this;
	}
};

EventEmitter.mixin = function mixin(obj) {
	/* jshint forin:false */
	for (var method in mixinPrototype) {
		obj[method] = mixinPrototype[method];
	}
	this.apply(obj);  // execute EventEmitter constructor in obj
	return obj;  // return 'this' for chaining
};

EventEmitter.prototype = mixinPrototype;


module.exports = EventEmitter;
